<template>
    <v-system-bar app class="px-4" color="#f5f5f5">
        Mitarbeiter@Services
    </v-system-bar>
</template>

<script>
    export default {
        name: "app-layout-system-bar"
    }
</script>

<style scoped>

</style>